import { css } from '@emotion/core'
import React from 'react'
import Band from '../components/band'
import Layout from '../components/layout'
import Page from '../components/page'
import Screen from '../components/screen'
import Slip from '../components/slip'
import Call from '../texts/call'
import Toc from '../texts/toc'

const Zine = () => {
  return (
    <Layout>
      <Screen
        css={css`
          background-color: orchid;
          color: floralwhite;
        `}
        layout={['center', 'center']}
        header={
          <div>
            <Band
              css={css`
                height: 2.5rem;
              `}
            >
              center for militant futurologi
            </Band>
            <Band
              css={css`
                background-color: hotpink;
                color: black;
              `}
            >
              noozine#2
            </Band>
          </div>
        }
        footer={
          <Slip
            css={css`
              color: thistle;
            `}
          />
        }
      >
        <h1
          css={css`
            font-size: calc(100vw / 12);
          `}
        >
          AI MONOLOGER
        </h1>
      </Screen>
      <Screen
        footer={
          <Slip
            css={css`
              color: blanchedalmond;
            `}
          />
        }
        css={css`
          background-color: thistle;
        `}
      >
        <Page>
          <Call />
        </Page>
      </Screen>
      <Screen
        css={css`
          background-color: blanchedalmond;
        `}
      >
        <Page>
          <Toc />
        </Page>
      </Screen>
    </Layout>
  )
}

export default Zine
